import { render, staticRenderFns } from "./MultipleSelector.vue?vue&type=template&id=c8cdf0b0"
import script from "./MultipleSelector.vue?vue&type=script&lang=js"
export * from "./MultipleSelector.vue?vue&type=script&lang=js"
import style0 from "./MultipleSelector.vue?vue&type=style&index=0&id=c8cdf0b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports